









































































  import Vue from 'vue';
  import AccessibilityStatementComponent
    from '@/components/global/AccessibilityStatementComponent.vue';
  export default Vue.extend({
    components: { AccessibilityStatementComponent },
  props: {
    height: {
      type: Number,
      default: 40,
    },
  },
  data() {
    return {
      showAccessibilityStatement: false
    }
  },
});
